import { lazy, Suspense } from 'react';
import { Route } from 'react-router-dom';
import { ErrorBoundary } from '@/app/composition/components/ErrorBoundary';
import { ProtectedRoute } from '@/platform/authentication/components/ProtectedRoute';
import { LoadingState } from '@/platform/design-system/components/ui/LoadingState';
import {
  FeatureFlagsPage,
  M365AppPage,
  MSPTenantDetail,
  MSPTenantList,
  PlatformAPIKeysPage,
  PlatformAuditPage,
  PlatformBillingPage,
  PlatformDashboardPage,
  PlatformHealthPage,
  PlatformLicensingPage,
} from '@/platform/tenant-administration/routes/lazyPages';

const PlatformShell = lazy(() =>
  import('@/app/composition/shells/PlatformShell').then(({ PlatformShell }) => ({
    default: PlatformShell,
  }))
);

export const PLATFORM_ROUTE_ELEMENT = (
  <Route
    path="/platform"
    element={
      <ProtectedRoute>
        <ErrorBoundary>
          <Suspense
            fallback={
              <LoadingState
                variant="skeleton-dashboard"
                label="Loading platform administration"
                description="Preparing tenant administration data."
                className="min-h-screen p-6"
              />
            }
          >
            <PlatformShell />
          </Suspense>
        </ErrorBoundary>
      </ProtectedRoute>
    }
  >
    <Route index element={<PlatformDashboardPage />} />
    <Route path="tenants" element={<MSPTenantList />} />
    <Route path="tenants/:id" element={<MSPTenantDetail />} />
    <Route path="licensing" element={<PlatformLicensingPage />} />
    <Route path="api-keys" element={<PlatformAPIKeysPage />} />
    <Route path="billing" element={<PlatformBillingPage />} />
    <Route path="health" element={<PlatformHealthPage />} />
    <Route path="m365" element={<M365AppPage />} />
    <Route path="feature-flags" element={<FeatureFlagsPage />} />
    <Route path="audit" element={<PlatformAuditPage />} />
  </Route>
);
